import type { JSX } from 'react';
import { MaterialChevronLeftSvg } from '../../../icons/icons';
import {
  strateNavigationButtonCVA,
  strateNavigationButtonIconCVA,
} from './StrateNavigationButton.cva';
import type { StrateNavigationButtonProps } from './StrateNavigationButton.types';

/**
 * Navigation button for the StrateNavigation component.
 * TODO: use ButtonV2 when available
 */
export function StrateNavigationButton({
  size = 'md',
  direction,
  verticalAlign = 'middle',
  isHidden = false,
  tabIndex,
  onClick,
  className,
  ...props
}: StrateNavigationButtonProps): JSX.Element {
  return (
    <button
      type="button"
      aria-hidden={isHidden}
      tabIndex={isHidden ? -1 : tabIndex}
      onClick={onClick}
      className={strateNavigationButtonCVA({
        size,
        direction,
        verticalAlign,
        isHidden,
        className,
      })}
      {...props}
    >
      <MaterialChevronLeftSvg
        aria-hidden
        role="img"
        className={strateNavigationButtonIconCVA({
          direction,
          size,
        })}
      />
    </button>
  );
}
